export const InfoIcon = () => {
  return (
    <svg data-icon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.75M9.25 6.25C9.25 5.83579 9.58579 5.5 10 5.5H10.0075C10.4217 5.5 10.7575 5.83579 10.7575 6.25V6.2575C10.7575 6.67171 10.4217 7.0075 10.0075 7.0075H10C9.58579 7.0075 9.25 6.67171 9.25 6.2575V6.25ZM8.95608 8.55844C10.1023 7.98532 11.3929 9.02061 11.0821 10.2639L10.3731 13.0999L10.4146 13.0792C10.7851 12.8939 11.2356 13.0441 11.4208 13.4146C11.6061 13.7851 11.4559 14.2356 11.0854 14.4208L11.0439 14.4416C9.8977 15.0147 8.60707 13.9794 8.91789 12.7361L9.6269 9.90008L9.58541 9.92082C9.21493 10.1061 8.76442 9.95589 8.57918 9.58541C8.39394 9.21493 8.54411 8.76442 8.91459 8.57918L8.95608 8.55844Z"
        className="fill-white"
      />
    </svg>
  );
};
